<template>
      <div>
        
        <small class="text-uppercase">{{ $t("short_description") }}</small>
        <br/>

        <input
          maxLength="1000"
          id="input-short_description"
          v-model.lazy="rpsScenario.short_description"
          tabindex="0" 
          @input="debounce_inputs"
          :class="!rpsScenario.short_description || rpsScenario.short_description.length === 0 ? 'error form-control' : 'form-control'"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('short_description')"
        />
        <br/>

        <small class="text-uppercase">{{ $t("start_title") }}</small>
        &nbsp;<base-button tabindex="-1" @click="showStartTitleHelp=!showStartTitleHelp" size="sm" type="primary">{{ $t('example') }}</base-button>
        <br/>
        <EditorHelpImage type="rps-scenario-start-title" v-if="showStartTitleHelp" />

        <input
          maxLength="1000"
          id="input-start_title"
          v-model.lazy="rpsScenario.start_title"
          tabindex="0" 
          @input="debounce_inputs"
          :class="!rpsScenario.start_title || rpsScenario.start_title.length === 0 ? 'error form-control' : 'form-control'"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('start_title')"
        />
        <br/>

        <small class="text-uppercase">{{ $t("start_description") }}</small>
        &nbsp;<base-button tabindex="-1" @click="showStartDescriptionHelp=!showStartDescriptionHelp" size="sm" type="primary">{{ $t('example') }}</base-button>
        <br/>
        <EditorHelpImage type="rps-scenario-start-description" v-if="showStartDescriptionHelp" />

        <textarea
          class="form-control"
          rows="5"
          v-if="false"
          id="input-start_description"
          v-model.lazy="rpsScenario.start_description"
          tabindex="0"
          @input="debounce_inputs"
          :class="['form-control', !rpsScenario.start_description || rpsScenario.start_description.length === 0 ? 'error' : '']"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('start_description')">
        </textarea>
        <br/>

        <vue-editor
          :editor-toolbar="customToolbar"
          v-model.lazy="rpsScenario.start_description"
          @input="debounce_inputs"
          id="input-start_description"
          tabindex="0"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('start_description')">
        </vue-editor>

        <small class="text-uppercase">{{ $t("begin_page_facilitator_instructions") }}</small>
        <br/>
        <textarea
          rows="5"
          id="input-begin_page_facilitator_instructions"
          v-model.lazy="rpsScenario.begin_page_facilitator_instructions"
          @input="debounce_inputs"
          tabindex="0"
          :class="['form-control', !rpsScenario.begin_page_facilitator_instructions || rpsScenario.begin_page_facilitator_instructions.length === 0 ? 'error' : '']"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('begin_page_facilitator_instructions')"
        />
        <br/>    

        <small class="text-uppercase">{{ $t("completion_title") }}</small>
        &nbsp;<base-button tabindex="-1" @click="showCompletionTitleHelp=!showCompletionTitleHelp" size="sm" type="primary">{{ $t('example') }}</base-button>
        <br/>
        <EditorHelpImage type="rps-scenario-completion-title" v-if="showCompletionTitleHelp" />

        <input
          maxLength="1000"
          id="input-completion_title"
          v-model.lazy="rpsScenario.completion_title"
          tabindex="0" 
          @input="debounce_inputs"
          :class="!rpsScenario.completion_title || rpsScenario.completion_title.length === 0 ? 'error form-control' : 'form-control'"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('completion_title')"
        />

        <br/>
        <small class="text-uppercase">{{ $t("completion_description") }}</small>
        &nbsp;<base-button tabindex="-1" @click="showCompletionDescriptionHelp=!showCompletionDescriptionHelp" size="sm" type="primary">{{ $t('example') }}</base-button>
        <br/>
        <EditorHelpImage type="rps-scenario-completion-description" v-if="showCompletionDescriptionHelp" />
        
        <textarea
          rows="5"
          id="input-completion_description"
          v-model="rpsScenario.completion_description"
          tabindex="0"
          :class="['form-control', !rpsScenario.completion_description || rpsScenario.completion_description.length === 0 ? 'error' : '']"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('completion_description')">
        </textarea>
        <br/>
        
        <small class="text-uppercase">{{ $t("last_page_facilitator_instructions") }}</small>
        <br/>
        <textarea
          rows="5"
          id="input-last_page_facilitator_instructions"
          v-model="rpsScenario.last_page_facilitator_instructions"
          tabindex="0"
          :class="['form-control']"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('last_page_facilitator_instructions')"
        />
        <br/>

        <small class="text-uppercase">{{ $t("reporting_facilitator_instructions") }}</small>
        <br/>
        <textarea
          rows="5"
          id="input-reporting_facilitator_instructions"
          v-model="rpsScenario.reporting_facilitator_instructions"
          tabindex="0"
          :class="['form-control']"
          v-b-tooltip.hover.bottom="otherLocalesHoverText('reporting_facilitator_instructions')"
        />

      </div>
  </template>
  
  <script>
 import Vue from "vue";
 import EditorHelpImage from "@/components/EditorHelpImage.vue";
 import { VueEditor, Quill } from "vue2-editor";

 const debounce = require("lodash.debounce");
///
function getFontName(font) {
    return font.toLowerCase().replace(/\s/g, "-");
}

const fontNames = [
  'Poppins',
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Verdana'
];

const fontList = [
  'Poppins',
  'Arial',
  'Helvetica',
  'Times New Roman',
  'Verdana'
];

const fonts = Quill.import('formats/font');
fonts.whitelist = fontNames;
Quill.register(fonts, true);

// Add fonts to CSS style
let fontStyles = "";
fontList.forEach((font) => {
    const fontName = getFontName(font);
    fontStyles += ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" + fontName + "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" + fontName + "]::before {" +
        "content: '" + font + "';" +
        "font-family: '" + font + "', sans-serif;" +
        "}" +
        ".ql-font-" + fontName + "{" +
        " font-family: '" + font + "', sans-serif;" +
        "}";
});

// https://stackoverflow.com/questions/68394460/add-font-style-and-font-size-in-vue2-editor

  export default {
    props: ["rpsScenario", "otherLocales"], 
    components: {
      EditorHelpImage,
    },

    data() {
      return {
        showStartDescriptionHelp: false,
        showStartTitleHelp: false,
        showCompletionTitleHelp: false,
        showCompletionDescriptionHelp: false,
        debounceDelay: 1000,
        customToolbar: [
    // Copied from source
    // https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    ["link"],
    [{ font: fonts.whitelist }],
]
    

      };
    },
    mounted() {
    },
    computed: {
    },
    methods: {
      // https://stackoverflow.com/a/42201508/76535
      debounce_inputs(e) {
        // Check if event and target exist
        if (!e || !e.target || !e.target.id) {
          return;
        }

        // assumes that input field's id is the same as member in rpsScenario, prefixed by 'input-'
        const field = e.target.id.replace('input-', '');

        if (e.target.value.length <= 1) {
          // Change immediately if field either cleared or inputted somehintg
          Vue.set(this.rpsScenario, field, e.target.value);
        } else {
          debounce(() => {
            Vue.set(this.rpsScenario, field, e.target.value);
          }, this.debounceDelay)(e)
        }
      },
      isValid() {
        return this.rpsScenario.start_description.length && this.rpsScenario.start_title.length && this.rpsScenario.completion_title.length && this.rpsScenario.completion_description.length && this.rpsScenario.short_description.length;
      },
      otherLocalesHoverText(field) {
        let locales = "";
        for (let i = 0; i < this.otherLocales.length; i++) {
          if (this.otherLocales[i][field] && this.otherLocales[i][field].length > 0) {
            locales += this.otherLocales[i].locale + ": " + this.otherLocales[i][field] + "\n";
          }
        }
        return locales;
      }
    },
  };
  </script>

<i18n>
   {
    "en": {
      "short_description": "Short description or name of the simulation. Only used when the simulation is selected. *",
      "start_title": "Title shown in the start page (before the first case) *",
      "start_description": "Description text shown in the start page *",
      "begin_page_facilitator_instructions": "Facilitator instructions shown in the intro page",
      "completion_title": "Title shown in the last page (after the last case, before reporting) *",
      "completion_description": "Description text shown in the last page *",
      "last_page_facilitator_instructions": "Facilitator instructions shown in the last page", 
      "reporting_facilitator_instructions": "Facilitator instructions shown in reporting - often not needed",
      "example": "Example"
    },
    "fi": {
      "short_description": "Simulaation lyhyt kuvaus. Käytetään ainoastaan peliä luodessa, simulaation valintalistauksessa. *",
      "start_title": "Aloitussivun otsikko (ennen ensimmäistä tilannetta) *",
      "start_description": "Aloitussivulla näytettävä kuvausteksti *",
      "begin_page_facilitator_instructions": "Aloitussivun pelinjohtajan ohjeet",
      "completion_title": "Viimeisen sivun otsikko (viimeisen tilanteen jälkeen, ennen raporttia) *",
      "completion_description": "Viimeisen sivun kuvausteksti *",
      "last_page_facilitator_instructions": "Viimeisen sivun pelinjohtajan ohjeet", 
      "reporting_facilitator_instructions": "Raporttisivun pelinjohtajan ohjeet - jätetään usein tyhjäksi",
      "example": "Esimerkki"
    }
  }
  </i18n>
  
<style scoped>
  ::v-deep .error {
    border-color: red !important;
  }
</style>
